export default function CoursesNavigation() {
  return (
    <ul id="wd-courses-navigation">
      <li>
        <a id="wd-course-home-link" href="#/Kanbas/Courses/1234/Home">
          Home
        </a>
      </li>
      <li>
        <a id="wd-course-modules-link" href="#/Kanbas/Courses/1234/Modules">
          Modules
        </a>
      </li>
      <li>
        <a id="wd-course-piazza-link" href="#/Kanbas/Courses/1234/Piazza">
          Piazza
        </a>
      </li>
      <li>
        <a id="wd-course-zoom-link" href="#/Kanbas/Courses/1234/Zoom">
          Zoom
        </a>
      </li>
      <li>
        <a id="wd-course-quizzes-link" href="#/Kanbas/Courses/1234/Assignments">
          Assignments
        </a>
      </li>
      <li>
        <a id="wd-course-assignments-link" href="#/Kanbas/Courses/1234/Quizzes">
          Quizzes
        </a>
      </li>
      <li>
        <a id="wd-course-grades-link" href="#/Kanbas/Courses/1234/Grades">
          Grades
        </a>
      </li>
    </ul>
  );
}
